import { vars } from "@frontend/styles";

export const CHART_HEIGHT = 320;

// Adjacent-pairs-validated: safe whenever only ring/row neighbors can end up
// next to each other (BarChart, LineChart, PieChart). Fixed order, never
// cycled or reordered — see frontend/styles/theme.css.ts (color.chart).
export const ADJACENT_CHART_PALETTE = [
  vars.color.chart[0],
  vars.color.chart[1],
  vars.color.chart[2],
  vars.color.chart[3],
  vars.color.chart[4],
] as const;

// All-pairs-validated: safe whenever any two colored marks can end up next
// to each other (BubbleChart, NetworkChart). One slot fewer than
// ADJACENT_CHART_PALETTE — never add a 5th here.
export const ALL_PAIRS_CHART_PALETTE = [
  vars.color.chart[0],
  vars.color.chart[1],
  vars.color.chart[2],
  vars.color.chart[3],
] as const;
